export function getSystemLogoUrl(system) {
    if (!system.logo) return undefined;
    if (system.logo.type === "svg") return system.logo.svg;
    if (system.logo.type === "raster") {
        return system.logo.thumbnail.webp || system.logo.thumbnail.png;
    }
    return undefined;
}

//# sourceMappingURL=system-utils.js.map